<template>
  <v-select density="compact" variant="outlined" flat>
    <template v-for="(slot, name) in $slots" v-slot:[name]="scope">
      <slot :name="name" v-bind="scope" />
    </template>
    <template #message="{ message }">
      <div class="d-flex align-center gap-2">
        <i-custom-warning-circle />
        <div>{{ message }}</div>
      </div>
    </template>
  </v-select>
</template>
